import React from 'react'
import PropTypes from 'prop-types'

class EmailTr extends React.Component {
  render() {
    return(
      <tr>
        <th className="fix-table-width">
          {this.props.fieldName}
        </th>
        <td>
          {this.props.fieldValue ? (
            <a className='styled-link pointer-hand'
               href={'mailto:' + this.props.fieldValue}>
              {this.props.fieldValue}
            </a>
          ) : (
            '-'
          )}
        </td>
      </tr>
    )
  }
}

EmailTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string
}

export default EmailTr
